import { gql } from '@apollo/client';

export const GQL_UPDATE_ACCOUNT = gql`
  mutation UPDATE_ACCOUNT($input: UpdateAccountInput!) {
    updateAccount(input: $input)
  }
`;
